import { useContext } from 'react'
import Translate from '../../i18n/Translate'
import { useQuery } from 'react-query'
import { ItinerariesContext } from '../../context/ItinerariesProvider'
import { I18nContext } from '../../context/I18nProvider'
//API
import Api from '../../api'
//Components
import ItineraryCard from '../../components/Itinerary/ItineraryCard'
import { SpinnerEllipsis } from '../../components/Spinners'

const ItinerariesList = () => {
    /*
        Leo del contexto las opciones seleccionadas; pueden modificar estas opciones los sgtes.componentes:
        -DestinationSearch (destino y tipo de experiencia) desde la Home y desde Itinerarios
        -DestinationFilter (destino, tipo de experiencia y tipo de viaje) desde Itinerarios
    */
    const { language } = useContext(I18nContext)
    const { contextSelectedOptions } = useContext(ItinerariesContext)
    const { destination, type_of_experience, type_of_travel } = contextSelectedOptions

    //Fetch a traves de react-query para obtener itinerarios segun opciones seleccionadas
    const { data: itineraries, status } = useQuery(
        ['itineraries-list', destination, type_of_experience, type_of_travel, language],
        () => Api.itineraries.list(destination, type_of_experience, type_of_travel, language)
    )

    return (
        <div className="itineraries-list">
            {status === 'loading' && <SpinnerEllipsis />}
            {status === 'error' && <p>Error</p>}
            {status === 'success' && itineraries.length === 0 && (
                <p>
                    <Translate langkey="itinerary.itinerary_list.no_results" />
                </p>
            )}

            {status === 'success' &&
                itineraries.length > 0 &&
                itineraries.map((itinerary) => {
                    return <ItineraryCard itinerary={itinerary} key={itinerary.id} />
                })}
        </div>
    )
}

export default ItinerariesList
